import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { IState } from "store/store.interface";
import { Box, Text } from "common";
import { MagnifyGlass } from "@mafc/icon";

const EmptyBulkJobs = () => {
  const { selectOptions, storeId } = useSelector((state: IState) => ({
    ...state.config,
    ...state.auth,
  }));

  const countryName = useMemo(() => {
    if (selectOptions) {
      const { countries = [] } = selectOptions;
      return (countries?.find((country) => country?.value === storeId) || {})?.label;
    }
    return "";
  }, [storeId, selectOptions]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      height="300px"
      alignItems="center"
      flexDirection="column"
      data-testid="empty-bulk-job-container"
    >
      <MagnifyGlass size="XL" fill="#4D4D4D" />
      <Text
        my="20px"
        data-testid="empty-bulk-job-text"
        color="text.secondary"
        fontSize="18px"
      >
        No Bulk Upload Job found {countryName ? `in ${countryName}` : ""}
      </Text>
    </Box>
  );
};

export default EmptyBulkJobs;
